import { TiSocialLinkedin } from "react-icons/ti";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { AiFillWechat } from "react-icons/ai";
import { Link } from "react-router-dom"
import { MdOutlineDoubleArrow } from "react-icons/md";




export default function Contact(){
    return(
        <div className="mt-[6rem] w-full mb-[1.5rem] md:mb-[2rem] lg:mb-[6rem]">

        <div className="pl-[3rem] md:pl-[5rem] lg:pl-[7rem] w-full bg-[rgb(238,238,238)] py-[1rem] md:py-[3rem] lg:py-[4rem] md:bg-[rgb(238,238,238)] lg:bg-transparent mb-[1.45rem] md:mb-[4rem] lg:mb-[4rem]">
        <h1 className="font-[12px] text-xl md:text-3xl lg:text-5xl poetsen-one-regular">
        Contact Us
        </h1>

        </div>

        <div className="w-full pl-0 items-start md:pl-0 lg:pl-[7rem]">
            <div className="items-start mb-[1rem] md:mb-[3rem] lg:mb-[5rem]"> 
                <h1 className='text-xl md:text-xl lg:text-3xl font-[12px] tracking-[1px] mb-[9px] md:mb-[12px] lg:mb-[1rem] poetsen-one-regular'>
                General and Business Inquiries:
                </h1>

                <p className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty mb-[1rem] josefin-sans-p'>
                For Inquiries and requests including RFP and competition invitations <br/>
email: <Link to=''>
                   
                    <span className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty underline hover:no-underline text-blue-400'>
                    global@archbuild.jp
                    </span>
                    </Link>
                </p>
            </div>


            <div className="items-start mb-[1rem] md:mb-[3rem] lg:mb-[5rem]">
                <h1 className='text-xl md:text-xl lg:text-3xl font-[12px] tracking-[1px] mb-[9px] md:mb-[12px] lg:mb-[1rem] poetsen-one-regular'>
                Press:
                </h1>

                <p className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty mb-[1rem] josefin-sans-p'>
                For Media Inquiries and Upcoming Events <br/>
email: <Link to=''>
                   
                    <span className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty underline hover:no-underline text-blue-400'>
                    media@archbuild.jp
                    </span>
                    </Link>
                </p>
            </div>

            <div className="items-start mb-[1rem] md:mb-[3rem] lg:mb-[5rem]">
                <h1 className='text-xl md:text-xl lg:text-3xl font-[12px] tracking-[1px] mb-[9px] md:mb-[12px] lg:mb-[1rem] poetsen-one-regular'>
                Career:
                </h1>

                <p className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty mb-[1rem] josefin-sans-p'>
                For Information <br/> <Link to=''>
                   
                    <span className='text-xs md:text-sm lg:text-lg font-[11px] text-pretty underline hover:no-underline text-blue-400'>  
https://www.archbuild.co.jp/en/career/
                    </span>
                    </Link>
                </p>
            </div>

        

        <div className="items-start">
            <h1 className="text-xl md:text-xl lg:text-3xl font-[12px] tracking-[1px] mb-[9px] md:mb-[12px] lg:mb-[1rem] poetsen-one-regular">
            <p className='caveat-logo text-3xl md:text-4xl lg:text-6xl'>Archbuild</p> Headquarters:
            </h1>

            <div>
            <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'>

</div>

<h1 className="mt-[10px] md:mt-[12px] lg:mt-[1.23rem] font-semibold text-sm lg:text-xl poetsen-one-regular">
Main Offices
</h1>


<p className="text-[rgb(73,73,73)] text-xs md:text-sm lg:text-sm josefin-sans-p">
Osaka, Nagoya, Kyushu, Tohoku
</p>
            </div>
        </div>



        

        <div>
           <h1 className='text-xl md:text-2xl lg:text-3xl font-[12px] mt-[1rem] md:mt-[2rem] lg:mt-[2rem] poetsen-one-regular'>
           Overseas Offices:
           </h1>
           
        </div>
        </div>






        <div className='w-full mt-[3rem] flex flex-col gap-4 justify-center md:lg-8 lg:gap-9'>
                    
                    <div className='flex flex-col md:flex-col lg:flex-row justify-center gap-4 md:gap-7 lg:gap-[13rem] w-full'>
                    <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 justify-center gap-[2rem]'>
                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Shanghai
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Room 3505, Bank of China Tower, 200 Yin-Cheng Rd. Central,
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Pudong New Area, Shanghai 200120, China 
                        </p>


                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +86-21-5037-2265 
                        </p>


                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +86-21-5037-2779
                        </p>
                    </div>



                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Beijing
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Room 1210, China World Tower 1, No.1 Jian Guo Men Wai Ave.,
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Chaoyang, Beijing 100004, China  
                        </p>


                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +86-10-6505-4606  
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +86-10-6505-4607  
                        </p>
                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Dalian
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Senmao Bldg. 5F, 147, Zhongshan lu, Dalian 116011, China 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +86-411-8364-8355 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +86-411-8365-7655
                        </p>

                        
                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Seoul
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        2017, 92, Saemunan-ro, Jongno-gu, Seoul 03186, Korea 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +822-568-4090
                        </p>


                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +822-568-4091
                        </p>

                        
                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Hanoi
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        #1706 17F, GELEX Tower, 52 Le Dai Hanh str. Hai Ba Trung Dist., 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Hanoi, Vietnam
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +84-24-3715-3698
                        </p>

                        
                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Ho Chi Minh
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Room 1004, 10th Floor, Zen Plaza Building, 54-56 Nguyen Trai
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Street, District 1, Ho Chi Minh City, Vietnam
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +84-28-3925-2570
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +84-28-3925-2571
                        </p>

                        
                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Singapore (Liaison Office)
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        182 Cecil Street, #17-85 Frasers Tower, Singapore 069547 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +65-6622-5330
                        </p>

                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Bangkok
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        11/1 AIA Sathorn Tower BLDG., 7th Floor. Room 706, 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        South Sathorn Road. Yannawa, Sathorn, Bangkok, 10120 Thailand
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +66-2-285-1233
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +66-2-285-1232
                        </p>

                    </div>




                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Dubai
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Office # 2903, The Burj Al Salam Tower, Trade Center First, Sh. 
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Zayed Rd., Dubai P.O.Box 27120, U.A.E.
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +971-4-3434269
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        FAX: +971-4-3218660
                        </p>

                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Riyadh
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Office #10, Al Izdihar Center 2, Uthman Ibn Affan Rd, Al Izdihar
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        District, Riyadh 12485, Kingdom of Saudi Arabia
                        </p>

                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

                    <div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
                        <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
                        Moscow
                        </h4>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        Ulitsa Usacheva, House 33, Bldg. 1, Moscow 119048, Russian Federation
                        </p>

                        <p className='font-semibold text-[rgb(136,136,136)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
                        TEL: +7-499-348-16-00
                        </p>

                    </div>


                    <div className='items-start flex flex-col gap-1 lg:gap-2'>

<div className='border-line w-full md:[w-14rem] lg:w-[20rem]'></div>
    <h4 className='font-[10px] text-sm md:text-lg lg:text-lg dancing-script-head'>
    Barcelona
    </h4>

    <p className='font-semibold text-[rgb(90,90,90)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
    Av.Diagonal 640, Planta 6, 08017 Barcelona Spain

    </p>

    <p className='font-semibold text-[rgb(88,88,88)] text-xs md:text-sm lg:text-sm josefin-sans-p'>
    TEL: +34 935 450 938
    </p>

</div>



                    </div>




                    </div>


                    

                    </div>
        

        

                    <div className="w-full pl-0 items-start md:pl-0 lg:pl-[7rem] mt-[1.56rem] md:mt-[3rem] lg:mt-[6rem]">
            <h1 className='font-semibold text-xl md:text-2xl lg:text-3xl poetsen-one-regular'>
                Social Media
            </h1>

           
        </div>

        <ul className='flex flex-col md:flex-col lg:flex-row w-full gap-7 md:gap-12 lg:gap-[5rem] justify-center mt-[1rem] md:mt-[2rem]lg:mt-[2.5rem]'>
        <Link>
                            <li className='flex items-center gap-1'>

                            <p className='bg-[rgb(129,129,129)] hover:bg-[rgb(243,209,99)]'>
                            <TiSocialLinkedin className='listed text-xl'/>
                            </p>
                            <p className='text-sm md:text-sm lg:text-lg font-semilight josefin-sans-p'>
                            Linkedin
                            </p>
                            <p>
                            <MdOutlineDoubleArrow className='text-xl'/>
                            </p>
                            
                            
                            </li>
</Link>
                            <Link>
                            <li className='flex items-center gap-1'>

                            <p className='bg-[rgb(129,129,129)] hover:bg-[rgb(243,209,99)]'>
                            <FaInstagram className='listed'/>
                            </p>
                            <p className='text-sm md:text-sm lg:text-lg font-semilight josefin-sans-p'>
                            Instagram
                            </p>
                            <p>
                            <MdOutlineDoubleArrow className='text-xl'/>
                            </p>
                            
                            
                            </li>
</Link>
                            <Link>
                            <li className='flex items-center gap-1'>

                            <p className='bg-[rgb(129,129,129)] hover:bg-[rgb(243,209,99)]'>
                            <FaXTwitter className='listed text-xl'/>
                            </p>
                            <p className='text-sm md:text-sm lg:text-lg font-semilight josefin-sans-p'>
                            Twitter
                            </p>
                            <p>
                            <MdOutlineDoubleArrow className='text-xl'/>
                            </p>
                            
                            
                            </li>
</Link>
                            <Link>
                            <li className='flex items-center gap-1'>

                            <p className='bg-[rgb(129,129,129)] hover:bg-[rgb(243,209,99)]'>
                            <FaFacebookF className='listed text-xl'/>
                            </p>
                            <p className='text-sm md:text-sm lg:text-lg font-semilight josefin-sans-p'>
                            Facebook
                            </p>
                            <p>
                            <MdOutlineDoubleArrow className='text-xl'/>
                            </p>
                            
                            
                            </li>
</Link>
                            <Link>
                            <li className='flex items-center gap-1'>

                            <p className='bg-[rgb(129,129,129)] hover:bg-[rgb(243,209,99)]'>
                            <AiFillWechat className='listed text-xl'/>
                            </p>
                            <p className='text-sm md:text-sm lg:text-lg font-semilight josefin-sans-p'>
                            Wechat
                            </p>
                            <p>
                            <MdOutlineDoubleArrow className='text-xl'/>
                            </p>
                            
                            
                            </li>
</Link>
                        </ul>


        </div>
    )
} 